import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import Table from "react-bootstrap/Table";
import Button from "react-bootstrap/Button";
import { app } from "../firebase";
import {
  getFirestore,
  collection,
  query,
  where,
  getDocs,
  doc,
  getDoc,
} from "firebase/firestore";
import Logo from "../Images/logoblack.svg";

const db = getFirestore(app);

const InvoicePage = () => {
  const { clientId } = useParams();
  const [orders, setOrders] = useState([]);
  const [client, setClient] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchClientData = async () => {
      try {
        let fetchedOrders = [];
        let clientData = null;

        // First, check if clientId matches a real Firestore client document
        const clientRef = doc(db, "clients", clientId);
        const clientSnap = await getDoc(clientRef);

        if (clientSnap.exists()) {
          // Case 1: Existing client (doc id)
          clientData = clientSnap.data();

          const q = query(
            collection(db, "Orders"),
            where("clientId", "==", clientId),
            where("paymentStatus", "==", "Unpaid")
          );
          const snap = await getDocs(q);
          fetchedOrders = snap.docs.map((doc) => ({
            id: doc.id,
            ...doc.data(),
          }));
        } else {
          // Case 2: New client (clientId is actually a name)
          const q = query(
            collection(db, "Orders"),
            where("newClientName", "==", decodeURIComponent(clientId)),
            where("paymentStatus", "==", "Unpaid")
          );
          const snap = await getDocs(q);
          fetchedOrders = snap.docs.map((doc) => ({
            id: doc.id,
            ...doc.data(),
          }));

          if (fetchedOrders.length > 0) {
            clientData = {
              full_name: decodeURIComponent(clientId),
              userphone: fetchedOrders[0].clientPhone || "N/A",
            };
          }
        }

        setClient(clientData);
        setOrders(fetchedOrders);
      } catch (err) {
        console.error("Error fetching invoice data:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchClientData();
  }, [clientId]);

  const total = orders.reduce(
    (sum, order) => sum + (parseFloat(order.toPrice) || 0),
    0
  );

  const today = new Date().toLocaleDateString();

  if (loading) return <p className="text-center mt-5">Loading...</p>;

  return (
    <div
      className="p-3 p-md-5 bg-white shadow rounded"
      style={{ maxWidth: "900px", margin: "auto" }}
    >
      {/* Header */}
      <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center mb-4">
        <img src={Logo} alt="Company Logo" style={{ height: "50px" }} />
        <div className="text-md-end mt-3 mt-md-0">
          <h4 className="mb-0">INVOICE</h4>
          <small>Date: {today}</small>
        </div>
      </div>

      {/* Client Info */}
      <div className="mb-4">
        <h6 className="fw-bold">Bill To:</h6>
        <p className="mb-0">
          <strong>Name:</strong> {client?.full_name || "N/A"}
        </p>
        <p className="mb-0">
          <strong>Phone:</strong> {client?.userphone || "N/A"}
        </p>
      </div>

      {/* Orders Table */}
      {orders.length === 0 ? (
        <p className="text-center">No deliveries found for this client.</p>
      ) : (
        <>
          <div className="table-responsive">
            <Table bordered size="sm" className="align-middle text-nowrap">
              <thead className="table-light">
                <tr>
                  <th>Order ID</th>
                  <th>Location</th>
                  <th>Price</th>
                  <th>Date & Time</th>
                </tr>
              </thead>
              <tbody>
                {orders.map((order) => {
                  let dateTime = "N/A";
                  if (order.timestamp) {
                    const date = order.timestamp.toDate();
                    dateTime = date.toLocaleString();
                  }
                  return (
                    <tr key={order.id}>
                      <td>{order.id}</td>
                      <td>{order.toLocation || "N/A"}</td>
                      <td>{order.toPrice ? `KES ${order.toPrice}` : "N/A"}</td>
                      <td>{dateTime}</td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
          </div>

          {/* Total */}
          <div className="text-end mt-3">
            <h5 className="fw-bold">Total: KES {total}</h5>
          </div>

          {/* Footer - show only on md and up */}
          <div className="mt-4 d-none d-md-flex justify-content-end">
            <Button variant="primary" onClick={() => window.print()}>
              Print / Download
            </Button>
          </div>
        </>
      )}
    </div>
  );
};

export default InvoicePage;